import { useQuery } from 'react-query';
import { useRouter } from 'next/router';
import { CompoundsApis } from '../../../new-lib/apis/compounds.apis';

const useCompoundLaunches = (compoundId: number) => {
  const {
    data: launches,
    isLoading,
    isError
  } = useQuery({
    queryKey: [`compound-launches-${compoundId}`, compoundId],
    queryFn: () => CompoundsApis.getCompoundLaunches(compoundId),
    staleTime: Infinity
  });

  return { launches: launches ?? [], isLoading, isError };
};

export default useCompoundLaunches;
